<div class="vb" *ngIf="state as s">
  <header class="vb__hdr">
    <button class="btn btn-link" (click)="back()">← Back to baskets</button>
    <h2 *ngIf="basket as b">Basket #{{ b.basketNumber }} — {{ b.patientName }}<span class="vb__dob"
        *ngIf="b.patientDob"> ({{ b.patientDob | dob }})</span></h2>
  </header>

  <div class="vb__body" *ngIf="basket as b">
    <ul class="vb__list">
      <li *ngFor="let m of b.medications" [attr.data-state]="rowState(m)">
        <span class="vb__check">{{ m.verifyScanStatus === 'Verified' ? '✓' : '✗' }}</span>
        <span class="vb__name">{{ m.medicationName }}</span>
        <app-med-badges [packSize]="m.packSize" [fullPacks]="m.fullPacks" [bagId]="m.bagId"
                        [marking]="m.marking" [doNotSubstitute]="m.doNotSubstitute"></app-med-badges>
        <span class="vb__qty" *ngIf="m.quantity != null">Qty {{ m.quantity }}</span>
        <span class="vb__tag" *ngIf="m.pickScanStatus === 'PickedAsSubstitute'">ALT</span>
        <span class="vb__tag vb__tag--miss" *ngIf="m.pickScanStatus === 'Missing'">MISSING</span>
      </li>
    </ul>

    <div class="vb__scan">
      <input #scanInput class="form-control" placeholder="Scan barcode..."
             [(ngModel)]="barcode" (keyup.enter)="scan()" autofocus>
    </div>

    <div class="vb__banner" *ngIf="banner" [ngClass]="'vb__banner--' + banner.type">{{ banner.text }}</div>

    <app-issue-banner *ngIf="issue"
                      [issue]="issue"
                      (moveNow)="moveNow()"
                      (defer)="defer()"
                      (dismiss)="dismiss()">
    </app-issue-banner>
  </div>
</div>
